import { useEffect, useState } from "react";
import { UilMessage } from "@iconscout/react-unicons";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneNumberInput from "components/inputs/PhoneNumberInput";

function ContactNumberContent() {
  const [inputValue, setInputValue] = useState("");
  const [selectValue, setSelectValue] = useState("043");
  const [contactNumber, setContactNumber] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errorStatus, setErrorStatus] = useState();

  const handleSelectChange = (event) => {
    const { value } = event.target;
    setSelectValue(value);
  };

  useEffect(() => {
    setContactNumber(selectValue + "-" + inputValue);
  }, [selectValue, inputValue]);

  async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.status === 200) {
      setInputValue("");
      setErrorStatus(200);

      const errorStatusNull = setTimeout(() => {
        setErrorStatus();
      }, 5000);
      return () => {
        clearTimeout(errorStatusNull);
      };
    } else {
      setErrorStatus(404);
    }

    return response.json();
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!captchaVerified) {
      setErrorStatus(1);
      return;
    }
    const url = "http://mailsender.j-coders.com/api/";
    const data = {
      phonenumber: contactNumber,
    };

    await postData(url, data);
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PhoneNumberInput
          selectChange={handleSelectChange}
          inputChange={setInputValue}
          value={inputValue}
        />
        <button
          type={captchaVerified ? "submit" : ""}
          disabled={!captchaVerified}
          className={captchaVerified ? "" : "disabled-btn"}
          aria-label={"Submit Number"}
        >
          <UilMessage />
        </button>
      </form>
      <div className="error__message">
        <h2 className={`${errorStatus === 200 ? "" : "error"}`}>
          {(errorStatus === 200 && "Your number has been sent successfully!") ||
            (errorStatus === 404 &&
              "An error occurred while processing your request.") ||
            (errorStatus === 1 &&
              "The captcha verification failed, preventing your request.")}
        </h2>
      </div>
      <div className="contact__number-recaptcha">
        <ReCAPTCHA
          sitekey="6LcEKx8nAAAAACt61BUaPDScjtZgjBSCgfzV15Hu"
          onChange={() => {
            setCaptchaVerified(true);
          }}
          onExpired={() => {
            setCaptchaVerified(false);
          }}
          size={"compact"}
        />
      </div>
    </>
  );
}

export default ContactNumberContent;
